// Get items by size
// {
//     paSizes(where: {name: "Small"}) {
//       nodes {
//         description
//         paSizeId
//         name
//         products {
//           nodes {
//             name
//           }
//         }
//         databaseId
//       }
//     }
//   }

import React, { Component } from "react";

class CategoryPage extends Component {
    render() {
        return this.props.children;
    }
}

export default CategoryPage;